<template>
  <section>
    <div class="bottom-navigation spacer d-xs-none d-xxxs-block" />
    <b-nav justified class="bottom-navigation d-xxs-flex d-xs-none px-0 bg-white border border-dark border-bottom-0 border-left-0 border-right-0 position-fixed w-100">
      <b-nav-item class="d-flex flex-column align-items-center" @click="ChangeTabToDemographic()">
        <img v-if="this.activeTab == this.profileTab.Demographic" height="32" src="@/assets/icons/profile-demographic-active.svg">
        <img v-else height="32" src="@/assets/icons/profile-demographic-inactive.svg">
        <span class="d-flex mt-1" :class="{'text-muted': this.activeTab != this.profileTab.Demographic}">
          {{ $t("UserProfile.Common.Demographics") }}
        </span>
      </b-nav-item>
      <b-nav-item class="d-flex flex-column align-items-center" @click="ChangeTabToWallet()">
        <img v-if="this.activeTab == this.profileTab.Wallet" height="32" src="@/assets/icons/profile-wallet-active.svg">
        <img v-else height="32" src="@/assets/icons/profile-wallet-inactive.svg">
        <span class="d-flex mt-1" :class="{'text-muted': this.activeTab != this.profileTab.Wallet}">
          {{ $t("UserProfile.Common.Wallet") }}
        </span>
      </b-nav-item>
      <b-nav-item v-if="!this.isNew" class="d-flex flex-column align-items-center" @click="ChangeTabToProductHistory()">
        <img v-if="this.activeTab == this.profileTab.ProductHistory" height="32" src="@/assets/icons/profile-game-controller-active.svg">
        <img v-else height="32" src="@/assets/icons/profile-game-controller-inactive.svg">
        <span class="d-flex mt-1" :class="{'text-muted': this.activeTab != this.profileTab.ProductHistory}">
          {{ $t("UserProfile.Common.Products", {products: this.globalResources.productTranslation.Plural}) }}
        </span>
      </b-nav-item>
      <b-nav-item v-if="this.isNew" class="d-flex flex-column align-items-center" @click="ChangeTabToSubscription()">
        <img v-if="this.activeTab == this.profileTab.Subscription" height="32" src="@/assets/icons/profile-subscription-active.svg">
        <img v-else height="32" src="@/assets/icons/profile-subscription-inactive.svg">
        <span class="d-flex mt-1" :class="{'text-muted': this.activeTab != this.profileTab.Subscription}">
          {{ $t("UserProfile.Common.Subscription") }}
        </span>
      </b-nav-item>
    </b-nav>
  </section>
</template>

<script>
import enums from '@/utilities/enums.js'
export default {
  name: 'UserProfileMobileBottomNavigation',
  mixins: [enums],
  props: {
    isNew: Boolean,
    activeTab: String
  },
  methods: {
    ChangeTabToDemographic () {
      this.$emit('ChangeTabToDemographic')
    },
    ChangeTabToWallet () {
      this.$emit('ChangeTabToWallet')
    },
    ChangeTabToProductHistory () {
      this.$emit('ChangeTabToProductHistory')
    },
    ChangeTabToSubscription () {
      this.$emit('ChangeTabToSubscription')
    }
  }
}
</script>
